export function getRegion() {
  const arr = JSON.parse(window.shippingRegion);
  const regions = [];
  const provinces = [];

  arr.forEach((element) => {
    let cName = '';
    let eName = '';

    switch (element.ChineseName) {
      case '台灣及離島':
        cName = '台灣本島及離島';
        eName = element.EnglishName;
        break;
      case '中國':
        cName = '中國大陸';
        eName = element.EnglishName;
        break;
      case '香港':
        cName = '香港SAR';
        eName = `${element.EnglishName} SAR`;
        break;
      case '澳門':
        cName = '澳門SAR';
        eName = `${element.EnglishName} SAR`;
        break;
      default:
        cName = element.ChineseName;
        eName = element.EnglishName;
        break;
    }

    regions.push({
      name: `${cName} ${eName}`,
      value: element.ID,
      eName,
    });
  });

  provinces.push({ name: '請選擇省份', value: '' });

  arr[1].Province.forEach((element) => {
    provinces.push({
      name: element.SimpleChineseName,
      value: element.ID,
    });
  });

  return { regions, provinces };
}

export function getLocalStorageByKey(key, subKey) {
  const sfEcDataLayerNow = JSON.parse(localStorage.getItem('sfEcDataLayer'));

  if (sfEcDataLayerNow && sfEcDataLayerNow[key]) {
    if (subKey && sfEcDataLayerNow[key][subKey]) {
      return sfEcDataLayerNow[key][subKey];
    }
    return sfEcDataLayerNow[key];
  }
  return undefined;
}

export const paymentOptions = {
  1: '信用卡線上刷卡',
  2: '貨到付款(宅配)',
  3: '貨到付款(超商)',
  4: '銀聯卡',
  5: 'ATM',
  6: '街口支付',
  7: 'LinePay',
  8: '實體門市付款',
  9: 'Fasney',
};

export const deliveryOptions = {
  1: '宅配',
  2: '7-11超商取貨',
  3: '全家、萊爾富、OK超商取貨',
  4: '海外配送',
  5: '員購自取',
  6: '門市取貨 (for Cody)',
  7: '全家超商取貨',
};

export function fireCartCheckoutGAEvent(parameters) {
  const { value, coupon, items } = parameters;

  if (value === undefined || items === undefined) return;

  const beginCheckoutDataLayer = {
    event: 'begin_checkout',
    currency: 'TWD',
    value,
    coupon,
    items,
  };

  window.dataLayer.push(beginCheckoutDataLayer);
  window.dataLayer.push({ items: null });
}

export function fireAddPaymentInfoGAEvent(parameters) {
  const { coupon, items, payType, value } = parameters;

  if (items === undefined || payType === undefined || value === undefined) {
    return;
  }

  const addPaymentInfoDataLayer = {
    event: 'add_payment_info',
    currency: 'TWD',
    value,
    coupon,
    payment_type: payType,
    items,
  };

  window.dataLayer.push(addPaymentInfoDataLayer);
  window.dataLayer.push({ items: null });
}

export function fireAddShippingInfoGAEvent(parameters) {
  const { coupon, items, shippingTier, value } = parameters;

  if (items === undefined || shippingTier === undefined || value === undefined) {
    return;
  }

  const addShippingInfoDataLayer = {
    event: 'add_shipping_info',
    currency: 'TWD',
    value,
    coupon,
    shippingTier,
    items,
  };

  window.dataLayer.push(addShippingInfoDataLayer);
  window.dataLayer.push({ items: null });
}

export function firePurchaseEvent(parameters) {
  const { coupon, items, shipping, transactionID, value } = parameters;

  if (items === undefined || transactionID === undefined || value === undefined) return;

  const purchaseDataLayer = {
    event: 'purchase',
    currency: 'TWD',
    transaction_id: transactionID,
    value,
    coupon,
    shipping,
    items,
  };

  window.dataLayer.push(purchaseDataLayer);
  window.dataLayer.push({ items: null });
}

export function deleteLocalStorageByKey(key) {
  if (localStorage.getItem(key)) {
    localStorage.removeItem(key);
  }
}

export function fireEventAddToWishList(itemInfo) {
  const { value, items } = itemInfo;

  if (!value) return;

  const dataLayerObj = {
    event: 'add_to_wishlist',
    currency: 'TWD',
    value,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireLoginGAEvent(loginInfo) {
  const { actionType, loginType } = loginInfo;

  const dataLayerObj = {
    event: 'login',
    method: loginType,
    Action_Type: actionType,
    Login_Type: loginType,
  };

  window.dataLayer.push(dataLayerObj);
}

export function fireRegisterGAEvent(registerInfo) {
  const { actionType, registerType } = registerInfo;

  const dataLayerObj = {
    event: 'sign_up',
    method: registerType,
    Action_Type: actionType,
    Register_Type: registerType,
  };

  window.dataLayer.push(dataLayerObj);
}

export function fireViewItemListGAEvent(parameters) {
  const { itemListName, items } = parameters;

  const dataLayerObj = {
    event: 'view_item_list',
    item_list_name: itemListName,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireAddToCartGAEvent(productInfo) {
  const { value, items } = productInfo;

  if (!value || !items) return;

  const dataLayerObj = {
    event: 'add_to_cart',
    currency: 'TWD',
    value,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireSearchGAEvent(parameters) {
  const { searchType, searchContent } = parameters;

  if (!searchType || !searchType) return;

  const dataLayerObj = {
    event: 'search',
    search_term: searchContent, // GA4 文件中
    Search_Type: searchType, // 外部廠商自己傳的
    Search_Content: searchContent, // 外部廠商自己傳的
  };

  window.dataLayer.push(dataLayerObj);
}

export function fireSelectItemGAEvent(parameters) {
  const { itemListName, items } = parameters;

  if (!itemListName || items.length === 0) return;

  const dataLayerObj = {
    event: 'select_item',
    item_list_name: itemListName,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireRemoveFromCartGAEvent(parameters) {
  const { value, items } = parameters;

  if (!value || items.length === 0) return;

  const dataLayerObj = {
    event: 'remove_from_cart',
    currency: 'TWD',
    value,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireEventRecommendedGoods(parameters) {
  const dataLayerObj = {
    event: 'recommended_goods',
    ...parameters,
  };

  window.dataLayer.push(dataLayerObj);
}

export function fireRefundGAEvent(parameters) {
  const { transactionID, value, shipping, items } = parameters;

  const dataLayerObj = {
    event: 'refund',
    currency: 'TWD',
    transaction_id: transactionID,
    value,
    shipping,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireMemberFavoriteCartGAEvent(parameters) {
  const { productId, productName, addFavoriteItem } = parameters;

  const dataLayerObj = {
    event: 'member',
    Member_List: '會員收藏清單',
    hash_ID: window.Email || undefined,
    Product_Id: productId,
    Product_Name: productName,
    Favorite_Add_To_Cart: addFavoriteItem,
  };

  window.dataLayer.push(dataLayerObj);
}

export function fireRecommendViewItemListGAEvent(payload) {
  const { itemListName, items } = payload;

  const dataLayerObj = {
    event: 'view_item_list',
    item_list_name: itemListName,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireEventPromotionBanner(payload) {
  const { promotionTargetUrl, promotionItems, promotionCreativeName, promotionCreativeSlot } =
    payload;

  const dataLayerObj = {
    event: 'Promotion_Banner',
    promotionTargrtUrl: promotionTargetUrl,
    promotionItems,
    promotionCreativeName,
    promotionCreativeSlot,
  };

  window.dataLayer.push(dataLayerObj);
}

export function fireCustomProductViewEvent(payload) {
  const { itemCategory, itemCategory2, itemCategory3, itemID, itemName } = payload;

  const eventDataLayer = {
    event: 'Product_View',
    Head_Button: itemCategory,
    Category_Button: itemCategory2,
    SubCategory_Button: itemCategory3,
    Product_Id: itemID,
    Product_Name: itemName,
    hash_ID: window.Email,
  };

  window.dataLayer.push(eventDataLayer);
}

export function fireProductViewGAEvent(payload) {
  const { items, value } = payload;

  if (!value) return;

  const dataLayerObj = {
    event: 'view_item',
    currency: 'TWD',
    value,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireListCategoryPushEvent(payload) {
  window.dataLayer.push({
    category: payload,
  });
}

export function fireSearchCategoryPushEvent(payload) {
  window.dataLayer.push({
    category: payload,
  });
}

export function fireViewCartEvent(parameters) {
  const { value, items } = parameters;

  if (value === undefined || items === undefined) return;

  const dataLayerObj = {
    event: 'view_cart',
    currency: 'TWD',
    value,
    items,
  };

  window.dataLayer.push(dataLayerObj);
  window.dataLayer.push({ items: null });
}

export function fireInStoreInventoryEvent(payload) {
  const { ProductId, ProductName, HashId, pColor, pSize, pStoreList } = payload;

  const eventDataLayer = {
    event: 'View_InStore_Inventory',
    Product_Id: ProductId,
    Product_Name: ProductName,
    Hash_Id: HashId,
    Color: pColor,
    Size: pSize,
    StoreList: pStoreList,
  };

  window.dataLayer.push(eventDataLayer);
}
